import { Link } from "react-router";
import Container from "~/components/shared/Container";
import { Button } from "~/components/ui/button";

import Image404 from "./404.png";
import { ROUTES } from "~/services/const";

export default function Play404() {
  return (
    <Container>
      <div className="min-h-[50vh] flex flex-col items-center justify-center gap-8 py-20">
        <h1 className="text-4xl font-bold text-gray-900">Peça não encontrada</h1>
        <img src={Image404} width={320} className="block" />
        <p className="text-gray-600 text-center max-w-md">
          Lamentamos, mas não conseguimos encontrar a peça que procura. Esta pode ter sido removida ou o link pode estar
          incorreto.
        </p>
        <Link to={ROUTES.HOME}>
          <Button className="bg-gray-900 hover:bg-orange-700 text-white">Voltar à página inicial</Button>
        </Link>
      </div>
    </Container>
  );
}
